<h1 class="content-main-title">{{ 'content.user-administration' | translate }}</h1>
<app-user-list
  [addNewRouterLink]="'/admin/users/new'"
  [canAddNew$]="guiPermissionsService.canAddUser()"
  [searchMode]="'manual'"
  [usersSubject]="usersSubject"
  (manualSearch)="searchForUser($event)"
  [caption]="'content.users-returned-by-search' | translate"
></app-user-list>
